import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app/App';
import { AnalyticsProvider } from './shared/context/AnalyticsContext';
import suppressResizeObserverErrors from './shared/utils/resizeObserverFix';
import { setupGlobalErrorHandler } from './shared/utils/errorHandler';
import { Provider } from 'react-redux';
import { store } from './shared/redux/store';
import Cryptique from 'cryptique-sdk';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const CRYPTIQUE_SITE_ID = '4e89ed67-38d3-457c-88a7-626d42372d51';

suppressResizeObserverErrors();
setupGlobalErrorHandler();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Great UX for back/forward navigation: show cached data instantly
      staleTime: 60_000, // 1 min
      gcTime: 10 * 60_000, // 10 min
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

async function bootstrap() {
  try {
    await Cryptique.init({
      siteId: CRYPTIQUE_SITE_ID,
      autoEvents: true,
      autoEventsDisabledPaths: [],
      autoEventsDisabledEvents: [],
    });
  } catch (e) {
    console.error('[Cryptique] init failed:', e);
  }

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <AnalyticsProvider>
            <App />
          </AnalyticsProvider>
        </QueryClientProvider>
      </Provider>
    </React.StrictMode>
  );
}

bootstrap();
